import { useCallback } from "react";
import { getServerSettings, getServerStats, indexServer, listBackups } from "../http/ServerAPI";
import { useAsyncData } from "./useAsyncData";

const mapBackups = (data) => (data?.backups || []).map(b => {
    const match = b.name.match(/\d{4}-\d{2}-\d{2}_\d{2}-\d{2}-\d{2}/);
    let dateTime = "Неизвестно";
    if (match) {
        const [date, time] = match[0].split('_');
        const formatted = `${date}T${time.replace(/-/g, ':')}`;
        const d = new Date(formatted);
        if (!isNaN(d)) dateTime = d.toLocaleString("ru-RU");
    }
    return {
        name: b.name,
        sizeMb: (b.size / (1024 * 1024)).toFixed(2),
        dateTime,
    };
});

const mapStats = (data) => (data || []).map(item => ({
    cpu: item.cpu_usage / 8,
    memory: item.memory_rss,
    time: new Date(item.CreatedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    fullTime: new Date(item.CreatedAt).toLocaleString('ru-RU', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}));

export const useServerSettingsData = (serverId) => {
    const settings = useAsyncData(() => getServerSettings(serverId), { deps: [serverId], initialData: null, errorMessage: "Ошибка загрузки настроек" });
    const server = useAsyncData(() => indexServer(serverId), { deps: [serverId], initialData: [], errorMessage: "Ошибка загрузки сервера" });
    const stats = useAsyncData(() => getServerStats(serverId), { deps: [serverId], initialData: null, mapData: mapStats, errorMessage: "Ошибка загрузки статистики" });
    const backups = useAsyncData(() => listBackups(serverId), { deps: [serverId], initialData: [], mapData: mapBackups, errorMessage: "Ошибка при получении бэкапов" });

    const reloadAll = useCallback(async () => {
        await Promise.allSettled([
            settings.reload(),
            server.reload(),
            stats.reload(),
            backups.reload(),
        ]);
    }, [settings.reload, server.reload, stats.reload, backups.reload]);

    return { settings, server, stats, backups, reloadAll };
};
